module.exports = __webpack_public_path__ + "static/media/WalmartCatalog_2018.4a62fd79.jpg";